import { useQuery } from '@tanstack/react-query';
import { fetchKeywordSuggestions } from './fetchKeywordSuggestions';
import { GlobalReactQueryOptions } from '../../../../config';
const KEYWORD_SUGGESTIONS_QUERY_KEY = 'keywordSuggestions';

export const useKeywordSuggestions = (input = '') => {
    return useQuery([KEYWORD_SUGGESTIONS_QUERY_KEY], () => fetchKeywordSuggestions(input), {
        ...GlobalReactQueryOptions,
        enabled: input.length > 2
    });
};
